import React from 'react'

const CrossIcon = props => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.43258 8.00571L15.2042 13.7773C15.5986 14.1713 15.5986 14.8103 15.2042 15.2042C14.8102 15.5986 14.1717 15.5986 13.7773 15.2042L8.00564 9.43261L2.2336 15.2042C1.84005 15.5986 1.20064 15.5986 0.806702 15.2042C0.412726 14.8103 0.412726 14.1713 0.806702 13.7773L6.57874 8.00571L0.795775 2.22277C0.401408 1.82841 0.401408 1.18982 0.795775 0.79588C0.992746 0.598485 1.25109 0.5 1.50944 0.5C1.76736 0.5 2.02571 0.598485 2.22271 0.79588L8.00564 6.57878L13.7773 0.807162C13.9747 0.610192 14.2326 0.511282 14.491 0.511282C14.7489 0.511282 15.0072 0.610192 15.2042 0.807162C15.5986 1.20114 15.5986 1.83969 15.2042 2.23406L9.43258 8.00571Z" />
  </svg>
)

export default CrossIcon
